// As abas Clube, Estudo e Cadernos da página do Mentor (Círculo, P2, 15/10/2026),
// para mentor-pagina.tsx.
//
// Marcação e classes do protótipo (clubeSec, estudoBlock e cadernosSec de
// docs/circulo-mentor/prototipo/circulo-do-mentor-piloto.html); os dados vêm de
// server/circulo/abas.js. Nada aqui inventa número: sem clube, sem meta ou sem
// caderno, a aba diz isso.
//
//   Clube    o clube do Mentor, os membros, o mural (só para membro) e Entrar/Abrir.
//            É grátis: nada aqui olha a assinatura.
//   Estudo   as metas do clube (club_milestones) — "até a p. tal" —, que é o
//            estudo que o clube já tem no app.
//   Cadernos o caderno pessoal de quem vê, para o livro da série; cria se faltar.
import React, { useState } from 'react';
import { api } from '../../services/apiV2';

const MESES_CURTOS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const dataCurta = (iso: string) => {
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso);
  return `${d.getDate()} ${MESES_CURTOS[d.getMonth()]}`;
};
const quando = (iso: string) => {
  const min = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  return d === 1 ? 'ontem' : d < 30 ? `há ${d} dias` : dataCurta(iso);
};
// "o clube Clube da Página" não: se o nome já começa com "clube", vai sem o artigo e o substantivo (QA #10).
export const oClubeNome = (nome: string) => (/^clube\b/i.test(String(nome || '').trim()) ? `o ${nome}` : `o clube ${nome}`);

const CORES = ['#4A3826', '#2E3A2A', '#3A2E40', '#2A3540', '#40302A'];
const corDe = (nome: string) => CORES[nome.split('').reduce((s, c) => s + c.charCodeAt(0), 0) % CORES.length];

const Avatar: React.FC<{ nome: string; url?: string | null }> = ({ nome, url }) => (
  <span className="avatar" style={{ '--av': corDe(nome) } as React.CSSProperties}>
    {url ? <img src={url} alt="" /> : (nome.trim()[0] || '·').toUpperCase()}
  </span>
);

/* ===== aba Clube ===== */
export const AbaClube: React.FC<{
  session: any; nome1: string; dados: any; erro: boolean;
  onRecarregar: () => void;
  onAbrirClube?: (clubId: string) => void;
  onAbrirClubes?: () => void;
  // Vitrine (sem conta, P4): entrar no clube leva ao cadastro e volta para esta aba.
  onEntrar?: (modo: 'register' | 'login') => void;
}> = ({ session, nome1, dados, erro, onRecarregar, onAbrirClube, onAbrirClubes, onEntrar }) => {
  const [entrando, setEntrando] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);

  // O título só promete "grátis, aberto para todos" se o clube existe e é aberto (QA #2).
  const c0 = dados?.clube;
  const cabeca = (
    <div className="sec-head"><div><span className="eyebrow">{c0 ? (c0.aberto ? 'Clube · grátis, aberto para todos' : 'Clube · fechado') : 'Clube'}</span>{(c0 || dados === undefined || erro) && <h2>Clube do Círculo</h2>}</div>
      {c0 && <p>A conversa do dia a dia de quem lê junto. É dentro dele que vive o Estudo.</p>}</div>
  );
  if (erro || dados === undefined) {
    return (
      <section className="sec" id="clube">{cabeca}
        <div className="club" data-clube-estado={erro ? 'erro' : 'carregando'}>
          <p>{erro ? 'Não deu para abrir o clube agora.' : 'Abrindo o clube…'}</p>
          {erro && <div className="btns" style={{ marginTop: 10 }}><button className="btn btn-2 btn-sm" onClick={onRecarregar}>Tentar de novo</button></div>}
        </div>
      </section>
    );
  }

  const c = dados.clube;
  if (!c) {
    return (
      <section className="sec" id="clube">{cabeca}
        <div className="club" data-clube-estado="sem-clube">
          {dados.sou_o_mentor ? (
            <>
              <h4>Você ainda não tem um clube aberto</h4>
              <p>O clube do Círculo é um clube aberto do qual você é o dono. Os seus clubes fechados continuam privados e não aparecem aqui.</p>
              {onAbrirClubes && <div className="btns" style={{ marginTop: 10 }}><button className="btn btn-2 btn-sm" onClick={onAbrirClubes}>Ir para os clubes</button></div>}
            </>
          ) : (
            <>
              <h4>{nome1} ainda não abriu um clube</h4>
              <p>Quando houver um, ele aparece aqui.</p>
            </>
          )}
        </div>
      </section>
    );
  }

  const entrar = async () => {
    if (!session) { onEntrar?.('register'); return; }
    setEntrando(true); setAviso(null);
    try {
      await api.joinClub(session, c.id);
      onRecarregar();
    } catch (e: any) {
      setAviso(e?.message || 'Não deu para entrar agora. Tente de novo.');
    } finally {
      setEntrando(false);
    }
  };

  const mural = dados.mural as null | any[];
  return (
    <section className="sec" id="clube">{cabeca}
      <div className="clube-sp" data-clube={c.id} data-membro={c.sou_membro ? '1' : '0'}>
        <div className="cl-l">
          <span className="free-tag">{c.aberto ? 'GRÁTIS · ABERTO PARA TODOS' : 'GRÁTIS · CLUBE FECHADO'}</span>
          <h2 data-clube-nome="">{c.nome}</h2>
          {c.descricao && <p>{c.descricao}</p>}
          <div className="avs"><span data-membros={c.membros}><b>{c.membros}</b> {c.membros === 1 ? 'membro' : 'membros'}</span></div>
          {c.livro && <p className="cm-clube-livro">Lendo agora: <b>{c.livro.titulo}</b>{c.livro.autor ? `, de ${c.livro.autor}` : ''}</p>}
          <div className="btns">
            {c.sou_membro
              ? onAbrirClube && <button className="btn btn-1" data-cta="abrir-clube" onClick={() => onAbrirClube(c.id)}>Abrir o clube</button>
              : c.aberto
                ? <button className="btn btn-ember" data-cta="entrar-clube" disabled={entrando} onClick={entrar}>{entrando ? 'Entrando…' : 'Entrar no clube'}</button>
                : <p className="cm-clube-nota">Clube fechado: só entra quem recebe o convite.</p>}
          </div>
          {aviso && <p className="cm-clube-nota" role="alert">{aviso}</p>}
        </div>
        <div className="mural" data-mural={mural ? mural.length : 'fechado'}>
          <div className="mural-h"><b>Mural</b><span>{mural ? 'as últimas mensagens' : 'só para quem está no clube'}</span></div>
          {!mural ? (
            <div className="post"><p>O mural é a conversa de quem está no clube. {c.aberto ? 'Entre, é grátis, para ler e escrever.' : ''}</p></div>
          ) : mural.length === 0 ? (
            <div className="post"><p>Ninguém escreveu no mural ainda.</p></div>
          ) : mural.map((p) => {
            const nome = p.autor?.nome || 'Leitor';
            return (
              <article key={p.id} className={`post ${p.do_mentor ? 'men' : ''}`} data-post="">
                <div className="ph"><Avatar nome={nome} url={p.autor?.avatar_url} /><b>{nome}</b><span>{quando(p.criado_em)}</span>
                  {p.do_mentor && <span className="kd">mentor</span>}</div>
                <p>{p.texto}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ===== aba Estudo ===== */
export const AbaEstudo: React.FC<{
  nome1: string; dados: any; erro: boolean; paginaDoLeitor: number;
  onRecarregar: () => void;
  onIrParaClube: () => void;
  onAbrirEstudo?: (clubId: string, bookId: string | null) => void;
}> = ({ nome1, dados, erro, paginaDoLeitor, onRecarregar, onIrParaClube, onAbrirEstudo }) => {
  const c = dados?.clube;
  const cabeca = (
    <div className="sec-head"><div><span className="eyebrow">Estudo</span><h2>A leitura, meta por meta</h2></div>
      <p>{c ? `O ritmo que ${oClubeNome(c.nome)} combinou: até que página ler, e até quando.` : 'Até que página ler, e até quando.'}</p></div>
  );
  const vazio = (titulo: string, texto: string, estado: string, botao?: React.ReactNode) => (
    <section className="sec" id="estudo">{cabeca}
      <div className="club" data-estudo-estado={estado}><h4>{titulo}</h4><p>{texto}</p>
        {botao && <div className="btns" style={{ marginTop: 10 }}>{botao}</div>}</div>
    </section>
  );

  if (erro) return vazio('Não deu para abrir o Estudo agora', 'Tente de novo em instantes.', 'erro', <button className="btn btn-2 btn-sm" onClick={onRecarregar}>Tentar de novo</button>);
  if (dados === undefined) return vazio('Abrindo o Estudo…', '', 'carregando');
  if (!c) return vazio(`${nome1} ainda não abriu um estudo`, 'O Estudo vive dentro do clube. Quando houver um, as metas de leitura aparecem aqui.', 'vazio');
  if (!dados.estudo) return vazio('O Estudo é de quem está no clube', `${c.nome} é um clube fechado.`, 'fechado');
  const marcos = dados.estudo.marcos as any[];
  const botaoClube = c.sou_membro
    ? onAbrirEstudo && <button className="btn btn-2 btn-sm" data-cta="abrir-estudo" onClick={() => onAbrirEstudo(c.id, dados.estudo.livro_id)}>Abrir o Estudo</button>
    : <button className="btn btn-2 btn-sm" data-cta="ir-clube" onClick={onIrParaClube}>Entrar no clube para estudar junto</button>;
  if (!marcos.length) {
    return vazio(`${nome1} ainda não abriu um estudo`,
      `${oClubeNome(c.nome).replace(/^o/, 'O')} existe, mas ainda não tem metas de leitura${c.livro ? ` para ${c.livro.titulo}` : ''}.`, 'vazio', botaoClube);
  }

  // Passou da meta (ou a meta foi encerrada) = feita; a primeira que falta é a de agora.
  const feita = (m: any) => m.encerrado || (paginaDoLeitor > 0 && paginaDoLeitor >= m.pagina);
  const agora = marcos.find((m) => !feita(m));
  return (
    <section className="sec" id="estudo">{cabeca}
      <div className="week" style={{ '--cols': marcos.length } as React.CSSProperties} data-metas={marcos.length}>
        {marcos.map((m) => {
          const cls = feita(m) ? 'past' : m === agora ? 'hoje' : 'next';
          return (
            <div key={m.n} className={`day ${cls}`} data-meta={m.n}>
              <div className="dh"><span>meta</span><b>{m.n}</b></div>
              <div className="evs"><div className={`ev ${cls === 'hoje' ? 'live' : ''}`}>
                <span className="k">{cls === 'past' ? 'feita' : cls === 'hoje' ? 'agora' : 'depois'}</span>
                <b>até a p. {m.pagina}</b>
                {m.rotulo && m.rotulo !== `Página ${m.pagina}` && <span>{m.rotulo}</span>}
              </div></div>
              <div className="plano"><span>{m.prazo ? `prazo: ${dataCurta(m.prazo)}` : 'sem prazo'}</span></div>
            </div>
          );
        })}
      </div>
      <div className="week-foot">
        <span><b>{marcos.length} {marcos.length === 1 ? 'meta' : 'metas'}</b>{c.livro ? ` · ${c.livro.titulo}` : ''}</span>
        <span>{c.membros} {c.membros === 1 ? 'pessoa' : 'pessoas'} no clube</span>
      </div>
      <div className="btns" style={{ marginTop: 14 }}>{botaoClube}</div>
    </section>
  );
};

/* ===== aba Cadernos ===== */
export const AbaCadernos: React.FC<{
  session: any; slug: string; nome1: string; dados: any; erro: boolean;
  onRecarregar: () => void;
  onMudou: (dados: any) => void;
  onAbrirCaderno?: (bookId: string) => void;
  onAbrirCadernos?: () => void;
  onEntrar?: (modo: 'register' | 'login') => void;
}> = ({ session, slug, nome1, dados, erro, onRecarregar, onMudou, onAbrirCaderno, onAbrirCadernos, onEntrar }) => {
  const [criando, setCriando] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);
  const cabeca = (
    <div className="sec-head"><div><span className="eyebrow">Seus Cadernos</span><h2>Suas notas, fora do Círculo</h2></div>
      <p>O Caderno é do app principal do Forjamente: pessoal e grátis, com ou sem assinatura do Círculo.</p></div>
  );
  const caixa = (estado: string, corpo: React.ReactNode) => (
    <section className="sec" id="cadernos">{cabeca}
      <div className="club" data-caderno-estado={estado}><span className="free">GRÁTIS · SEM ASSINATURA</span>{corpo}</div>
    </section>
  );

  if (!session) return caixa('entrar', <><h4>Crie a sua conta para ter o seu Caderno</h4><p>Com a sua conta, grátis, as notas sobre este livro ficam guardadas no seu Caderno pessoal.</p>
    {onEntrar && <div className="btns" style={{ marginTop: 10 }}>
      <button className="btn btn-1 btn-sm" data-cta="criar-caderno" onClick={() => onEntrar('register')}>Criar conta grátis</button>
      <button className="btn btn-2 btn-sm" data-cta="entrar-caderno" onClick={() => onEntrar('login')}>Já tenho conta · Entrar</button>
    </div>}</>);
  if (erro) return caixa('erro', <><p>Não deu para abrir o seu Caderno agora.</p>
    <div className="btns" style={{ marginTop: 10 }}><button className="btn btn-2 btn-sm" onClick={onRecarregar}>Tentar de novo</button></div></>);
  if (dados === undefined) return caixa('carregando', <p>Abrindo o seu Caderno…</p>);
  if (!dados.serie) return caixa('sem-serie', <><h4>Ainda não há livro aqui</h4><p>Quando {nome1} abrir a primeira série, o Caderno do livro dela fica a um toque daqui.</p></>);

  const todos = onAbrirCadernos && <button className="btn btn-2 btn-sm" onClick={onAbrirCadernos}>Ver todos os meus Cadernos</button>;
  const cad = dados.caderno;
  if (cad && dados.livro) {
    return caixa('tem', <>
      <h4 data-caderno-nome="">{cad.nome || dados.livro.titulo}</h4>
      <p data-notas={cad.notas}>{cad.notas === 0 ? 'Nenhuma nota ainda' : `${cad.notas} ${cad.notas === 1 ? 'nota' : 'notas'}`}{cad.atualizado_em ? ` · mexido em ${dataCurta(cad.atualizado_em)}` : ''}</p>
      <div className="btns" style={{ marginTop: 10 }}>
        {onAbrirCaderno && <button className="btn btn-1 btn-sm" data-cta="abrir-caderno" onClick={() => onAbrirCaderno(dados.livro.id)}>Abrir meu Caderno</button>}
        {todos}
      </div>
    </>);
  }

  const criar = async () => {
    setCriando(true); setAviso(null);
    try {
      const r = await api.criarMentorCaderno(session, slug);
      onMudou(r);
      if (r?.livro?.id && onAbrirCaderno) onAbrirCaderno(r.livro.id);
    } catch (e: any) {
      setAviso(e?.message || 'Não deu para criar agora. Tente de novo.');
    } finally {
      setCriando(false);
    }
  };
  return caixa('criar', <>
    <h4>{dados.serie.titulo}</h4>
    <p>Você ainda não tem um Caderno para este livro. {dados.livro ? '' : 'Ao criar, o livro entra na sua estante como "próximo". '}As suas notas ficam separadas do conteúdo de {nome1}.</p>
    <div className="btns" style={{ marginTop: 10 }}>
      <button className="btn btn-1 btn-sm" data-cta="criar-caderno" disabled={criando} onClick={criar}>{criando ? 'Criando…' : 'Criar meu Caderno'}</button>
      {todos}
    </div>
    {aviso && <p role="alert">{aviso}</p>}
  </>);
};
